 function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import styled from '@emotion/styled'
import graphql from 'babel-plugin-relay/macro'
import React, {useState} from 'react'
import { useFragment, usePaginationFragment, usePreloadedQuery} from 'react-relay'
import useGetUsedServiceTaskIds from '~/hooks/useGetUsedServiceTaskIds'
import useLoadNextOnScrollBottom from '~/hooks/useLoadNextOnScrollBottom'
import MockScopingList from '~/modules/meeting/components/MockScopingList'




import GitLabIssueId from '../shared/gqlIds/GitLabIssueId'
import getNonNullEdges from '../utils/getNonNullEdges'
import {parseWebPath} from '../utils/parseWebPath'
import Ellipsis from './Ellipsis/Ellipsis'
import GitLabScopingSelectAllIssues from './GitLabScopingSelectAllIssues'
import IntegrationScopingNoResults from './IntegrationScopingNoResults'
import NewGitLabIssueInput from './NewGitLabIssueInput'
import NewIntegrationRecordButton from './NewIntegrationRecordButton'
import ScopingSearchResultItem from './ScopingSearchResultItem'

const ResultScroller = styled('div')({
  overflow: 'auto'
})

const LoadingNext = styled('div')({
  display: 'flex',
  height: 32,
  fontSize: 24,
  justifyContent: 'center',
  width: '100%'
})






const GitLabScopingSearchResults = (props) => {
  const {queryRef, meetingRef} = props

  const query = usePreloadedQuery(
    graphql`
      query GitLabScopingSearchResultsQuery(
        $teamId: ID!
        $queryString: String!
        $selectedProjectsIds: [String!]
        $sort: String!
        $state: String!
      ) {
        ...GitLabScopingSearchResults_query
        viewer {
          ...NewGitLabIssueInput_viewer
          teamMember(teamId: $teamId) {
            integrations {
              gitlab {
                auth {
                  provider {
                    id
                  }
                }
              }
            }
          }
        }
      }
    `,
    queryRef
  )

  const paginationRes = usePaginationFragment


(
    graphql`
      fragment GitLabScopingSearchResults_query on Query
      @argumentDefinitions(cursor: {type: "String"}, count: {type: "Int", defaultValue: 25})
      @refetchable(queryName: "GitLabScopingSearchResultsPaginationQuery") {
        viewer {
          teamMember(teamId: $teamId) {
            integrations {
              gitlab {
                projectsIssues(
                  projectsIds: $selectedProjectsIds
                  first: $count
                  after: $cursor
                  searchQuery: $queryString
                  state: $state
                  sort: $sort
                ) @connection(key: "GitLabScopingSearchResults_projectsIssues") {
                  error {
                    message
                  }
                  edges {
                    node {
                      ... on _xGitLabIssue {
                        ...GitLabScopingSelectAllIssues_issues
                        id
                        iid
                        title
                        webPath
                        webUrl
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    `,
    query
  )
  const lastItem = useLoadNextOnScrollBottom(paginationRes, {}, 25)
  const {hasNext, data} = paginationRes
  const projectsIssues = _optionalChain([data, 'access', _ => _.viewer, 'access', _2 => _2.teamMember, 'optionalAccess', _3 => _3.integrations, 'access', _4 => _4.gitlab, 'access', _5 => _5.projectsIssues])
  const nullableEdges = _optionalChain([projectsIssues, 'optionalAccess', _6 => _6.edges])
  const errorMessage = _nullishCoalesce(_optionalChain([projectsIssues, 'optionalAccess', _7 => _7.error, 'optionalAccess', _8 => _8.message]), () => ( null))

  const meeting = useFragment(
    graphql`
      fragment GitLabScopingSearchResults_meeting on PokerMeeting {
        id
        teamId
        phases {
          ...useGetUsedServiceTaskIds_phase
          phaseType
        }
      }
    `,
    meetingRef
  )
  const {viewer} = query
  const teamMember = viewer.teamMember
  const {integrations} = teamMember
  const {gitlab} = integrations
  const {id: meetingId, phases} = meeting
  const providerId = gitlab.auth.provider.id
  const issues = nullableEdges ? getNonNullEdges(nullableEdges).map(({node}) => node) : null
  const [isEditing, setIsEditing] = useState(false)
  const estimatePhase = phases.find(({phaseType}) => phaseType === 'ESTIMATE')
  const usedServiceTaskIds = useGetUsedServiceTaskIds(estimatePhase)
  const handleAddIssueClick = () => setIsEditing(true)

  if (!issues) return React.createElement(MockScopingList, null )
  if (issues.length === 0 && !isEditing) {
    return (
      React.createElement(React.Fragment, null
        , React.createElement(IntegrationScopingNoResults, { error: errorMessage, msg: 'No issues match that query',} )
        , React.createElement(NewIntegrationRecordButton, { onClick: handleAddIssueClick, labelText: 'New Issue',} )
      )
    )
  }
  return (
    React.createElement(React.Fragment, null
      , React.createElement(GitLabScopingSelectAllIssues, {
        usedServiceTaskIds: usedServiceTaskIds,
        issuesRef: issues,
        meetingId: meetingId,
        providerId: providerId,}
      )
      , React.createElement(ResultScroller, null
        , query && (
          React.createElement(NewGitLabIssueInput, {
            isEditing: isEditing,
            meetingId: meetingId,
            setIsEditing: setIsEditing,
            viewerRef: viewer,}
          )
        )
        , issues.map((issue) => {
          const {id, iid, title, webUrl, webPath} = issue
          const {fullPath} = parseWebPath(_nullishCoalesce(webPath, () => ( '')))
          const linkText = `#${iid} ${fullPath}`

          return (
            React.createElement(ScopingSearchResultItem, {
              key: id,
              service: 'gitlab',
              usedServiceTaskIds: usedServiceTaskIds,
              serviceTaskId: GitLabIssueId.join(providerId, _nullishCoalesce(id, () => ( ''))),
              meetingId: meetingId,
              summary: _nullishCoalesce(title, () => ( '')),
              url: _nullishCoalesce(webUrl, () => ( '')),
              linkText: linkText,
              linkTitle: linkText,}
            )
          )
        })
        , lastItem
        , hasNext && (
          React.createElement(LoadingNext, { key: 'loadingNext',}
            , React.createElement(Ellipsis, null )
          )
        )
      )
      , !isEditing && (
        React.createElement(NewIntegrationRecordButton, { onClick: handleAddIssueClick, labelText: 'New Issue',} )
      )
    )
  )
}

export default GitLabScopingSearchResults
